/** @format */

import { useContext, useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import ModalCustom from '../../Shared/Components/ModalCustom';
import Pagination from '../../Shared/Components/Pagination';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { countOfRecourd, formatSidLabel } from '../../Shared/utils/helper';
import Master from '../Layouts/Master';

const MyTeamUsers = () => {
  const eventContext = useContext(EventContext);
  const { teamId, eventId } = useParams();
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [imageViewModalOpen, setImageViewModalOpen] = useState(false);
  const [imageViewSrc, setImageViewSrc] = useState(false);

  useEffect(() => {
    getUsers();
  }, [search, teamId]);
  const getUsers = async () => {
    setLoading(true);
    await useApi.get(
      `/team/event/${eventId}/my-team/${teamId}/users`,
      {},
      (res) => {
        eventContext.users = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  const educations = (key) => {
    let educations = [
      { key: 1, value: 'بی سواد' },
      { key: 2, value: 'ابتدایی' },
      { key: 3, value: 'دیپلم' },
      { key: 4, value: 'کاردانی' },
      { key: 5, value: 'کارشناسی' },
      { key: 6, value: 'کارشناسی ارشد' },
      { key: 7, value: 'دکترا' },
      { key: 8, value: 'پسا دکترا' },
    ];

    return educations.find((e) => e.key === key)?.value;
  };

  const openImage = (src) => {
    setImageViewSrc(src);
    setImageViewModalOpen(true);
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست کاربران ثبت نام شده
          </h1>
        </div>
        <span className='f-16 text-secondary'>
          تعداد ثبت نامی‌: {eventContext.users?.meta?.pagination?.total ?? 0}{' '}
          نفر
        </span>
      </div>

      <div className='w-100 overflow-auto'>
        {eventContext.users?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>صدور آی دی کارت</th>
                <th>تصویر</th>
                <th>سمت</th>
                <th>نام و نام خانوادگی</th>
                <th>نام پدر</th>
                <th>کد ملی</th>
                <th>شماره همراه</th>
                <th>تاریخ تولد</th>
                <th>جنسیت</th>
                <th>مدرک تحصیلی</th>
                <th>استان</th>
                <th>شهرستان</th>
                <th>نام باشگاه</th>
                <th>تلفن باشگاه</th>
                <th>آدرس باشگاه</th>
                <th>شاخه مسابقه</th>
                <th>وزن</th>
                <th>فایل</th>
                <th>نام سازمان</th>
                <th>عنوان قرارداد</th>
                <th>کد شناسه استخدامی</th>
                <th>رشته</th>
                <th>نامه تایید مدیریت سازمان</th>
                <th>حکم کارگزینی</th>
                <th>تصویر معرفی نامه</th>
                <th>تصویر تعهد نامه</th>
                <th>تصویر کارت ملی</th>
                <th>تصویر شناسنامه</th>
                <th>تصویر بیمه ورزشی</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.users?.data?.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    {countOfRecourd(
                      index,
                      eventContext.users?.meta?.pagination?.per_page,
                      eventContext.users?.meta?.pagination?.current_page,
                    )}
                  </td>

                  <td>
                    <img
                      src={item?.avatar}
                      onClick={() => openImage(item?.avatar)}
                      className='w-100 c-pointer'
                      alt='avatar'
                    />
                  </td>
                  <td>{formatSidLabel(item)}</td>
                  <td>
                    {item?.first_name} {item?.last_name}
                  </td>
                  <td>{item?.father_name ?? '-'}</td>
                  <td>{item?.nat_code ?? '-'}</td>
                  <td>{item?.mobile ?? '-'}</td>
                  <td>{item?.birth_date ?? '-'}</td>
                  <td>{item?.gender === 1 ? 'مرد' : 'زن'}</td>
                  <td>{educations(item?.education) ?? '-'}</td>
                  <td>{item?.province?.name ?? '-'}</td>
                  <td>{item?.city ?? '-'}</td>
                  <td>{item?.club_name ?? '-'}</td>
                  <td>{item?.club_phone ?? '-'}</td>
                  <td>{item?.club_address ?? '-'}</td>
                  <td>{item?.competition_branch ?? '-'}</td>
                  <td>{item?.weight ?? '-'}</td>
                  <td>
                    {item?.file !== null && item?.file !== undefined ? (
                      <a
                        download={true}
                        href={item.file}
                        target='_blank'
                        className='btn btn-danger btn-sm c-pointer text-white'
                      >
                        دانلود
                      </a>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>{item?.organization ?? '-'}</td>
                  <td>{item?.contract_title ?? '-'}</td>
                  <td>{item?.employment_id ?? '-'}</td>
                  <td>{item?.field_name ?? '-'}</td>
                  <td>
                    {item?.organization_letter !== null &&
                    item?.organization_letter !== undefined ? (
                      <img
                        onClick={() => openImage(item?.organization_letter)}
                        src={item?.organization_letter}
                        className='w-100 c-pointer'
                        alt='avatar'
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {item?.recruitment_order !== null &&
                    item?.recruitment_order !== undefined ? (
                      <img
                        onClick={() => openImage(item?.recruitment_order)}
                        src={item?.recruitment_order}
                        className='w-100 c-pointer'
                        alt='avatar'
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {item?.picture_cover_letter !== null &&
                    item?.picture_cover_letter !== undefined ? (
                      <img
                        onClick={() => openImage(item?.picture_cover_letter)}
                        src={item?.picture_cover_letter}
                        className='w-100 c-pointer'
                        alt='avatar'
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {item?.picture_commitment_letter !== null &&
                    item?.picture_commitment_letter !== undefined ? (
                      <img
                        onClick={() =>
                          openImage(item?.picture_commitment_letter)
                        }
                        src={item?.picture_commitment_letter}
                        className='w-100 c-pointer'
                        alt='avatar'
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {item?.national_card_picture !== null &&
                    item?.national_card_picture !== undefined ? (
                      <img
                        onClick={() => openImage(item?.national_card_picture)}
                        src={item?.national_card_picture}
                        className='w-100 c-pointer'
                        alt='avatar'
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {item?.birth_certificate_picture !== null &&
                    item?.birth_certificate_picture !== undefined ? (
                      <img
                        onClick={() =>
                          openImage(item?.birth_certificate_picture)
                        }
                        src={item?.birth_certificate_picture}
                        className='w-100 c-pointer'
                        alt='avatar'
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {item?.insurance_picture !== null &&
                    item?.insurance_picture !== undefined ? (
                      <img
                        onClick={() => openImage(item?.insurance_picture)}
                        src={item?.insurance_picture}
                        className='w-100 c-pointer'
                        alt='avatar'
                      />
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <span className='f-13 font-weight-bold text-secondary'>
              کاربری ثبت نام نکرده است
            </span>
          </div>
        )}
      </div>
      <Pagination
        totalPage={eventContext.users?.meta?.pagination?.total_pages}
        basePath={`/panel/event/register/${teamId}`}
        search={search}
      />

      <ModalCustom modalIsOpen={imageViewModalOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>مشاهده و دانلود تصویر</span>
        </div>
        <div className='d-flex flex-column justify-content-center align-items-center my-3'>
          <img
            src={imageViewSrc}
            alt='donload'
            className='img-thumbnail'
            style={{ height: '300px' }}
          />
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setImageViewModalOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            بستن
          </button>
          <a
            download={true}
            href={imageViewSrc}
            target='_blank'
            className='btn btn-success w-48 f-13'
          >
            دانلود
          </a>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default MyTeamUsers;
